import request from '../request'

export function getMessageList(params) {
    return request({
        url: `console/messages`,
        method: 'GET',
        params
    })
}

export function getMessageDetail(messageId) {
    return request({
        url: `console/messages/${messageId}`,
        method: 'GET'
    })
}